export default __webpack_public_path__ + "static/char-s-39-zh-Hans-745e959bc58e566ce4fa4caa67fc3a33.png";